import React from 'react';
import { Alert, Button, notification, Result } from 'antd';
import { MassiveApiError, toMassiveError } from 'services/MassiveErrors';

const SUPPORT_HINT =
  'El sistema no está respondiendo. Volvé a intentar en unos minutos; si sigue igual, avisá a soporte.';

const DEFAULT_TITLE = 'No se pudo completar la acción';

interface Props {
  error: unknown;
  title?: string;
  onRetry?: () => void;
}

export const notifyMassiveError = (error: unknown, title = DEFAULT_TITLE) => {
  const massiveError = toMassiveError(error);
  notification.error({
    message: title,
    description: massiveError.message,
    duration: massiveError.unreachable ? 0 : 4.5,
  });
};

export const MassiveErrorAlert = ({
  error,
  title = DEFAULT_TITLE,
  onRetry,
}: Props) => {
  const massiveError: MassiveApiError = toMassiveError(error);
  return (
    <Alert
      type="error"
      showIcon
      message={title}
      description={massiveError.message}
      action={
        onRetry ? (
          <Button size="small" danger onClick={onRetry}>
            Reintentar
          </Button>
        ) : null
      }
    />
  );
};

const MassiveServiceError = ({
  error,
  title = DEFAULT_TITLE,
  onRetry,
}: Props) => {
  const massiveError: MassiveApiError = toMassiveError(error);
  if (!massiveError.unreachable) {
    return <MassiveErrorAlert error={error} title={title} onRetry={onRetry} />;
  }
  return (
    <Result
      status="500"
      title={title}
      subTitle={SUPPORT_HINT}
      extra={
        onRetry ? (
          <Button type="primary" onClick={onRetry}>
            Reintentar
          </Button>
        ) : null
      }
    />
  );
};

export default MassiveServiceError;
